var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 166,
    viewBox: "0 0 167 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 70.2207H128C128 102.201 101.98 128.221 70 128.221V140.221C108.66 140.221 140 108.881 140 70.2207Z",
    fill: "#2E3191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140 70.2207H128C128 38.2407 101.98 12.2207 70 12.2207C38.02 12.2207 12 38.2407 12 70.2207C12 102.201 38.02 128.221 70 128.221V140.221C31.34 140.221 0 108.881 0 70.2207C0 31.5607 31.34 0.220703 70 0.220703C108.66 0.220703 140 31.5607 140 70.2207Z",
    fill: "#2E3191"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.98 130.81L131.54 120.25L135.01 123.72L124.45 134.28L120.98 130.81ZM126.65 136.48L137.21 125.92L138.62 127.33L128.06 137.89L126.65 136.48ZM131.35 141.18L155.96 165.79L166.52 155.23L141.91 130.62L131.35 141.18Z",
    fill: "#2E3191"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.49 32.9909C87.92 30.9109 84.06 29.3609 80.02 28.3909C76.87 27.6409 73.64 27.2409 70.4 27.2109C70.27 27.2109 70.14 27.2109 70 27.2109V33.1509C76.31 33.1509 82.62 34.7809 88.11 37.8909C92 40.0909 95.49 42.9909 98.35 46.4309L102.92 42.6209C103.19 42.4009 97.15 36.9009 96.58 36.4509C94.96 35.1709 93.26 34.0109 91.48 32.9809L91.49 32.9909Z",
    fill: "#2E3191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c9636d0f541dced46b332b2a84aa04bb.svg";
export { ForwardRef as ReactComponent };